import React,{useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiRefreshCw,FiHome,FiMail,FiPhone,FiShare2,FiTwitter,FiFacebook,FiLinkedin}=FiIcons;

const EndScreen=({score,onPlayAgain,onBackToStart})=> {
const [email,setEmail]=useState('');
const [showEmailForm,setShowEmailForm]=useState(false);

const getPerformanceMessage=()=> {
if (score <=50) {
return {title: "You're chasing zombies! 🧟‍♂️",message: "Let me show you real sales.",color: "text-red-400"};
} else if (score <=150) {
return {title: "Good instinct! 👻",message: "Ready to learn the real system?",color: "text-yellow-400"};
} else {
return {title: "Sales Hunter! 🏆",message: "Want to turn this into real clients?",color: "text-green-400"};
}
};

const getSalesTip=()=> {
const tips=[
"Real sales: Focus on qualified leads,not everyone","B2B truth: Not every prospect is your client","Hunter mindset: Quality over quantity","Stop chasing zombies. Find real opportunities."
];
return tips[Math.floor(Math.random() * tips.length)];
};

const handleEmailSubmit=(e)=> {
e.preventDefault();
if (email) {
alert('Thanks! You\'ll receive the First Client System guide soon.');
setEmail('');
setShowEmailForm(false);
}
};

const shareText=`I scored ${score} points in Sales Hunter: Halloween Edition! Can you beat me?`;
const shareUrl=window.location.href;
const performance=getPerformanceMessage();

return (
<div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-4">
<motion.div initial={{opacity: 0,scale: 0.8}} animate={{opacity: 1,scale: 1}} transition={{duration: 0.8}} className="text-center mb-8" >
<h1 className="text-6xl md:text-8xl font-bold text-orange-400 mb-4"> GAME OVER </h1>
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.2}} className="bg-black bg-opacity-70 rounded-lg p-6 mb-6" >
<div className="text-4xl font-bold text-white mb-2"> Final Score: <span className={performance.color}>{score}</span> </div>
<h2 className={`text-2xl font-bold mb-2 ${performance.color}`}> {performance.title} </h2>
<p className="text-lg text-gray-300 mb-4"> {performance.message} </p>
<div className="bg-purple-900 bg-opacity-50 rounded-lg p-4 mb-4">
<h3 className="text-orange-400 font-bold mb-2">💡 Sales Tip:</h3>
<p className="text-gray-300 italic">"{getSalesTip()}"</p>
</div>
</motion.div>
</motion.div>
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.4}} className="bg-black bg-opacity-60 rounded-lg p-6 mb-6 max-w-md w-full" >
<h3 className="text-xl font-bold text-orange-400 mb-4 text-center"> Ready for Real Sales Success? </h3>
{!showEmailForm ? (
<div className="space-y-3">
<a href="https://www.mathiasdeppe.com/the-one-page-client-getting-machine" target="_blank" rel="noopener noreferrer" className="w-full bg-gradient-to-r from-green-500 to-blue-600 text-white py-3 px-4 rounded-lg font-bold hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2" >
<SafeIcon icon={FiMail} />
Get the First Client System
</a>
<a href="https://tidycal.com/mathiasdeppe/clarity-call" target="_blank" rel="noopener noreferrer" className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-3 px-4 rounded-lg font-bold hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2" >
<SafeIcon icon={FiPhone} />
Book Free 15min Clarity Call
</a>
</div>
) : (
<form onSubmit={handleEmailSubmit} className="space-y-3">
<input type="email" value={email} onChange={(e)=> setEmail(e.target.value)} placeholder="Enter your email" required className="w-full px-4 py-3 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-orange-400 focus:outline-none" />
<button type="submit" className="w-full bg-gradient-to-r from-green-500 to-blue-600 text-white py-3 px-4 rounded-lg font-bold hover:scale-105 transition-transform duration-200" > Send Me the Guide </button>
<button type="button" onClick={()=> setShowEmailForm(false)} className="w-full text-gray-400 hover:text-white transition-colors duration-200" > Cancel </button>
</form>
)}
</motion.div>
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.6}} className="bg-black bg-opacity-60 rounded-lg p-4 mb-6 max-w-md w-full" >
<h4 className="text-lg font-bold text-orange-400 mb-3 text-center flex items-center justify-center gap-2"> <SafeIcon icon={FiShare2} /> Share Your Score </h4>
<div className="flex justify-center space-x-4">
<button onClick={()=> window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,'_blank')} className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-lg transition-colors duration-200" > <SafeIcon icon={FiTwitter} /> </button>
<button onClick={()=> window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`,'_blank')} className="bg-blue-700 hover:bg-blue-800 text-white p-3 rounded-lg transition-colors duration-200" > <SafeIcon icon={FiFacebook} /> </button>
<button onClick={()=> window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,'_blank')} className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-lg transition-colors duration-200" > <SafeIcon icon={FiLinkedin} /> </button>
</div>
</motion.div>
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.8}} className="flex space-x-4" >
<button onClick={onPlayAgain} className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 rounded-lg font-bold hover:scale-105 transition-transform duration-200 flex items-center gap-2" > <SafeIcon icon={FiRefreshCw} /> Hunt Again </button>
<button onClick={onBackToStart} className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-bold transition-colors duration-200 flex items-center gap-2" > <SafeIcon icon={FiHome} /> Main Menu </button>
</motion.div>
</div>
);
};

export default EndScreen;